<template>
  <div>
    <EditRecruiterFreelancer
      :id="id"
      :name="name"
      :email="email"
      :currency="currency"
      :rates="rates"
      :job-title="jobTitle"
      :tags="tags"
      :links="links"
      :files="files"
      :show="showEditModal"
      @cancel="toggleShowEditModal"
    />
    <DeleteRecruiterFreelancer
      :id="id"
      :contact-name="name"
      :show="showDeleteModal"
      @cancel="toggleShowDeleteModal"
    />
    <WdsMenu :z-index="21" placement="left-start" global>
      <template #trigger>
        <WdsButtonGhost>
          <WdsIcon name="overflow-menu-horizontal" class="tw-cursor-pointer" :size="16" />
        </WdsButtonGhost>
      </template>
      <WdsMenuOption data-test="recruiter-candidate-edit" @click="toggleShowEditModal">
        <WdsIcon :size="16" name="edit"></WdsIcon>
        {{ $t('Edit candidate') }}
      </WdsMenuOption>
      <WdsMenuOption
        theme="DESTRUCTIVE"
        data-test="recruiter-candidate-delete"
        @click="toggleShowDeleteModal"
      >
        <WdsIcon :size="16" name="trash-can"></WdsIcon>
        {{ $t('Delete candidate') }}
      </WdsMenuOption>
    </WdsMenu>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import { WdsMenu, WdsButtonGhost, WdsIcon, WdsMenuOption } from '@worksome/wds-components'
import EditRecruiterFreelancer from '@/components/Contacts/RecruiterFreelancer/EditRecruiterFreelancer.vue'
import DeleteRecruiterFreelancer from '@/components/Contacts/RecruiterFreelancer/DeleteRecruiterFreelancer.vue'

defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: Object,
    default: {
      firstName: '',
      middleName: '',
      lastName: '',
    },
    validator: (obj) =>
      ['firstName', 'middleName', 'lastName'].every(
        (key) => !!obj[key] && typeof obj[key] === 'string',
      ),
  },
  email: {
    type: String,
    required: true,
  },
  currency: {
    type: String,
    required: true,
  },
  rates: {
    type: Object,
    default: () => {},
  },
  jobTitle: {
    type: String,
    default: null,
  },
  tags: {
    type: Array,
    default: () => [],
  },
  links: {
    type: Array,
    default: () => [],
  },
  files: {
    type: Array,
    default: () => [],
  },
})

const showEditModal = ref(false)
function toggleShowEditModal() {
  showEditModal.value = !showEditModal.value
}

const showDeleteModal = ref(false)
function toggleShowDeleteModal() {
  showDeleteModal.value = !showDeleteModal.value
}
</script>
